﻿const descSort = (prop) => (a, b) => a[prop] < b[prop] ? -1 : 1;
export default descSort;